'use strict';
// Declare app level module which depends on views, and components
var iconoglobe = angular.module('iconoglobe', [
    "oc.lazyLoad",
    'ui.router',
    "ui.router.state.events",
    "pascalprecht.translate",
    "tmh.dynamicLocale",
    "ngSlimScroll",
    "ngAnimate",
    "ngSanitize",
    "ui.bootstrap",
    "smart-table",
    'angular.chosen', 
    'angularFileUpload',
    "720kb.socialshare",
    "infinite-scroll",
    "localStorage",
    "satellizer",
    "angular-google-analytics",
    "updateMeta",
    "cgNotify"
])
    .service('LocaleService', function ($translate, LOCALES, $rootScope, tmhDynamicLocale) {
        'use strict';
        // VARS
        var localesObj = LOCALES.locales;
        // locales and locales display names
        var _LOCALES = Object.keys(localesObj);
        if (!_LOCALES || _LOCALES.length === 0) {
            console.error('There are no _LOCALES provided');
        }
        var _LOCALES_DISPLAY_NAMES = [];
        _LOCALES.forEach(function (locale) {
            _LOCALES_DISPLAY_NAMES.push(localesObj[locale]);
        });
        var currentLocale = $translate.proposedLanguage();// because of async loading
        // METHODS
        var checkLocaleIsValid = function (locale) {
            return _LOCALES.indexOf(locale) !== -1;
        };
        var setLocale = function (locale) {
            if (!checkLocaleIsValid(locale)) {
                return;
            }
            startLoadingAnimation();
            currentLocale = locale;
            traceLog('language-select', "using translate ", locale)
            $translate.use(locale);
        };
        /**
         * Stop application loading animation when translations are loaded
         */
        var $html = angular.element('html');
        var LOADING_CLASS = 'app-loading';
        function startLoadingAnimation() {
            $html.addClass(LOADING_CLASS);
        }
        function stopLoadingAnimation() {
            $html.removeClass(LOADING_CLASS);
        }
        // EVENTS
        $rootScope.$on('$translateChangeSuccess', function (event, data) {
            
            document.documentElement.setAttribute('lang', data.language);// sets "lang" attribute to html
            // var language = data.language.toLowerCase().replace(/_/g, '-')
            var language = data.language.toLowerCase().split("_")[0];
            if (language === "ch") {
                language = "zh";
            }
            tmhDynamicLocale.set(language);// load Angular locale
        });
        // Synchronize AngularJS locale even if the initial
// translation-change event occurred before this listener.
var currentLanguage = $translate.proposedLanguage() || $translate.use();
 
if (currentLanguage) {
    var angularLocale = currentLanguage.toLowerCase().split("_")[0];

    if (angularLocale === "ch") {
        angularLocale = "zh";
    }

    tmhDynamicLocale.set(angularLocale);
}
        $rootScope.$on('$localeChangeSuccess', function () {
            stopLoadingAnimation();
        });
        return {
            getLocaleDisplayName: function () {
                if (localesObj[currentLocale] == undefined)
                    currentLocale = "en_US";
                return localesObj[currentLocale];
            },
            setLocaleByDisplayName: function (localeDisplayName) {
                setLocale(
                    _LOCALES[
                        _LOCALES_DISPLAY_NAMES.indexOf(localeDisplayName)// get locale index
                        ]
                );
            },
            getLocalesDisplayNames: function () {
                return _LOCALES_DISPLAY_NAMES;
            }
        };
    })
	
	
    .constant('LOCALES', {
        'locales': {
            'en_US': ['English', "https://iconoglobe.com"],
            'zh_ZH': ['中文', "https://zh.iconoglobe.com"],
            'es_ES': ['Español', "https://es.iconoglobe.com"],
            'ru_RU': ['Русский', "https://ru.iconoglobe.com"],
            'pt_PT': ['Português', "https://pt.iconoglobe.com"],
            'ja_JA': ['日本語', "https://ja.iconoglobe.com"],
            'fr_FR': ['Français', "https://fr.iconoglobe.com"],
            'ar_AR': ['العربية', "https://ar.iconoglobe.com"],
            'de_DE': ['Deutsche', "https://de.iconoglobe.com"],
            'id_ID': ['Indonesia', "https://id.iconoglobe.com"],
            'it_IT': ['Italiano', "https://it.iconoglobe.com"],
            'ko_KO': ['한국어', "https://ko.iconoglobe.com"],
            'no_NO': ['Norsk', "https://no.iconoglobe.com"],
            'pl_PL': ['Polski', "https://pl.iconoglobe.com"],
            'nl_NL': ['Nederlands', "https://nl.iconoglobe.com"],
            'fa_FA': ['فارسی', "https://fa.iconoglobe.com"],
            'sv_SV': ['Svenska', "https://sv.iconoglobe.com"],
            'vi_VI': ['Tiếng Việt', "https://vi.iconoglobe.com"],
            'tr_TR': ['Türk', "https://tr.iconoglobe.com"],
            'sl_SL': ['Slovenski', "https://sl.iconoglobe.com"],
            'sr_SR': ['Српски', "https://sr.iconoglobe.com"],
            'cs_CS': ['Čeština', "https://cs.iconoglobe.com"],
            'da_DA': ['Dansk', "https://da.iconoglobe.com"],
            'hr_HR': ['Hrvatski', "https://hr.iconoglobe.com"],
            'lt_LT': ['lietuvių kalba', "https://lt.iconoglobe.com"],
            'hu_HU': ['Magyar', "https://hu.iconoglobe.com"],
            'ro_RO': ['Română', "https://ro.iconoglobe.com"],
            'fi_FI': ['Suomi', "https://fi.iconoglobe.com"],
            'el_EL': ['ελληνικά', "https://el.iconoglobe.com"],
            'bg_BG': ['български', "https://bg.iconoglobe.com"],
            'uk_UK': ['український', "https://uk.iconoglobe.com"],
            'he_HE': ['עִברִית', "https://he.iconoglobe.com"],
            'af_AF': ['Afrikaans', "https://af.iconoglobe.com"],
            'km_KM': ['ខ្មែរ', "https://km.iconoglobe.com"],
            'bs_BS': ['Bosanski', "https://bs.iconoglobe.com"],
           'hi_HI': ['हिंदी', "https://hi.iconoglobe.com"]
        },
        'preferredLocale': 'en_US'
    });
    
    angular.module('iconoglobe')
.run(function($rootScope, $window) {

    // ========================================
    // EXISTING SHARED VIEW FUNCTIONALITY
    // ========================================

    var params = new URLSearchParams(window.location.search);

    if (params.get("data")) {
        $rootScope.isSharedView = true;
        
    }


    // ========================================
    // GLOBAL ENTERTAINMENT / NEWS MODE
    // ========================================

    var savedMode = $window.localStorage.getItem('ig-globe-mode');

    $rootScope.globeMode =
        savedMode === 'news' ? 'news' : 'entertainment';


    // Universal mode switching function
    $rootScope.setGlobeMode = function(mode) {

        if (mode !== 'news' && mode !== 'entertainment') {
            return;
        }

        $rootScope.globeMode = mode;
    };


    // Keep the body class and saved mode synchronized
    $rootScope.$watch('globeMode', function(mode) {

        var isNews = mode === 'news';

        document.body.classList.toggle('ig-news-mode', isNews);

        $window.localStorage.setItem(
            'ig-globe-mode',
            isNews ? 'news' : 'entertainment'
        );

    });

});